import get from 'lodash/get'
import times from 'lodash/times'
import React from 'react'
import Flex from 'components/ui/flex'
import Skeleton from 'components/ui/skeleton'
import Card from './card'

const toNumber = (x: number | string): number =>
  typeof x === 'string' ? parseFloat(x.replace(/,/g, '.')) : x

type Props = {
  data: Record<string, any>
  disabled?: boolean
  loading?: boolean
  showPercentage?: boolean
}

// TODO: Rename Card component to something more suitable
const StatsSummary = ({ data, disabled, loading, showPercentage }: Props) => {
  return loading ? (
    <Flex spacing="large">
      {times(3, (index: number) => (
        <Card key={index} title={<Skeleton />} value={<Skeleton />} />
      ))}
    </Flex>
  ) : (
    <Flex spacing="large">
      <Card
        title="Tracks Added"
        value={get(data, 'current_period.tracks_added', '')}
        percentage={
          showPercentage &&
          toNumber(get(data, 'change.percent_tracks_added', 0))
        }
      />
      <Card
        title="Playlists Created"
        value={get(data, 'current_period.playlists_created', '')}
        percentage={
          showPercentage &&
          toNumber(get(data, 'change.percent_playlists_created', 0))
        }
      />
      <Card
        title="Uploads Received"
        value={get(data, 'current_period.uploads_received', '')}
        percentage={
          showPercentage &&
          toNumber(get(data, 'change.percent_uploads_received', 0))
        }
      />
    </Flex>
  )
}

export default React.memo<Props>(StatsSummary)
